import styled from 'styled-components';
export const FlexGrow = styled.div.withConfig({
  displayName: "StyledComponents__FlexGrow",
  componentId: "sc-18cr1gt-0"
})(["flex-grow:1;"]);
export const FlexShrink = styled.div.withConfig({
  displayName: "StyledComponents__FlexShrink",
  componentId: "sc-18cr1gt-1"
})(["flex:1;word-break:normal;"]);
export const Flex = styled.div.withConfig({
  displayName: "StyledComponents__Flex",
  componentId: "sc-18cr1gt-2"
})(["display:flex;align-items:center;"]);
export const Small = styled.small.withConfig({
  displayName: "StyledComponents__Small",
  componentId: "sc-18cr1gt-3"
})(["display:block;line-height:16px;"]);